jQuery( document ).ready(function($) {
    $(window).on('scroll', function(){
        if( $(window).scrollTop() > 200) {
            $('#header').addClass('sticky');
        } else {
            $('#header').removeClass('sticky');
        }   
    });

    $('#offices .pin').hover(
        function(e) {
            let target = ".office[data-id='"+ $(this).attr('data-id') +"']";
            $(this).addClass('active');
            $(target).addClass('active');
            console.log($(target));
        }, function(e) {
            let target = '.office[data-id="'+ $(this).attr('data-id') +'"]'
            $(this).removeClass('active');
            $(target).removeClass('active');
        }
    );

    $('#offices .office').hover(
        function(e) {
            let target = '.pin[data-id='+ $(this).attr('data-id') +']'
            $(this).addClass('active');
            $(target).addClass('active');
        }, function(e) {
            let target = '.pin[data-id='+ $(this).attr('data-id') +']'
            $(this).removeClass('active');
            $(target).removeClass('active');
        }
    );

    $('.menu-toggle').on('click', function(e){
        e.preventDefault();
        $('.menu-toggle').toggleClass('open');
        $('#header .menu-left').toggleClass('open');
        $('#header .menu-right').toggleClass('open');
    })

    $('#popup-dismiss').on('click', function(e){
        e.preventDefault();
        console.log('Popup Dismissed')
        $('#popmake-2615').trigger('pumSetCookie');
        setTimeout(function(){
            $('#popmake-2615').popmake('close');
        }, 200); // 5 seconds
    })
  
});